import React from 'react';
import './SingleContentToFeedCTA.scss';
import CommonCardShell from '../../Layout/CommonCardShell/CommonCardShell';
import { EmitMetric } from '../../Analytics/VisibilityPixel/VisibilityPixel';

const SingleContentToFeedCTA = () => {
    const handleClick = () => {
        EmitMetric({
            misc_event_type: 'content-feed-cta-click',
            misc_event_count: 1,
        });
    };

    return (
        <CommonCardShell className="component-CallToAction-SingleContentToFeedCTA">
            <div className="cta-content">
                <h4>You&apos;re invited.</h4>
                <h6>See what women are sharing on Fairygodboss.</h6>
                <a href="/community/feed" onClick={handleClick}>
                    What&apos;s new today
                </a>
            </div>
        </CommonCardShell>
    );
};

SingleContentToFeedCTA.displayName = 'SingleContentToFeedCTA';

export default React.memo(SingleContentToFeedCTA);
